// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container general */
.Header_container__vI36D {
  max-width: 1140px;
  width: 100%;
  margin: auto;
  padding: auto;
  display: flex;
  align-items: center;
  height: 100%;
}

.Header_header__HXQOm {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(12, 6, 6, 0.1);
  position: fixed; /* Face header-ul fix */
  top: 0;
  z-index: 1000;
  transition: transform 0.3s ease, opacity 0.3s ease;
  height: 60px; /* Înălțime fixă */
}

.Header_header__HXQOm.Header_visible__hx\\+eL {
  transform: translateY(0);
  opacity: 1;
}

.Header_header__HXQOm.Header_hidden__h44Et {
  transform: translateY(-100%);
  opacity: 0;
}

i {
  padding-right: 3px;
}

.Header_logo__UsziS {
  display: flex;
  flex: 1 1;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0px;
  height: 100%;
}

.Header_logo__UsziS img {
  max-height: 55px;
  height: 100%;
}

.Header_desktopNav__bvTpA {
  flex: 2 1;
  display: flex;
  justify-content: center;
}

.Header_desktopNav__bvTpA ul {
  list-style: none;
  display: flex;
  gap: 20px;
  margin: 0;
  padding: 0;
}

.Header_desktopNav__bvTpA a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  transition: color 0.3s ease;
}

.Header_desktopNav__bvTpA a:hover {
  color: #e63946;
}

.Header_rightActions__0DN0s {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

.Header_rightActions__0DN0s a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  transition: color 0.3s ease;
}

.Header_rightActions__0DN0s a:hover {
  color: #e63946;
}

/* Buton hamburger */
.Header_hamburger__0Oz-R {
  display: none;
  font-size: 1.5rem;
  background: none;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  cursor: pointer;
  padding: 0;
  margin: 0;
  padding: 5px 15px;
  margin-right: 20px;
}

.Header_hamburger__0Oz-R i {
  color: #7f7f7f;
  padding: 0;
  margin: 0;
}

/* Meniul mobil */
.Header_mobileNav__2MJ\\+H {
  display: none;
  flex-direction: column;
  align-items: flex-end;
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  width: 100%;
  padding: 10px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.Header_mobileNav__2MJ\\+H ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.Header_mobileNav__2MJ\\+H a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  text-align: right;
  width: 100%;
  padding: 10px 0;
}

.Header_mobileNav__2MJ\\+H a:hover {
  color: #e63946;
}

/* Responsive */
@media (max-width: 768px) {
  .Header_logo__UsziS {
    margin-left: 15px;
  }

  .Header_desktopNav__bvTpA {
    display: none;
  }

  .Header_hamburger__0Oz-R {
    display: block;
  }

  .Header_rightActions__0DN0s {
    display: none;
  }

  .Header_mobileNav__2MJ\\+H {
    display: none;
  }

  .Header_mobileNav__2MJ\\+H.Header_open__coLd6 {
    display: flex;
  }
}

.Header_sup__3QohI {
  background-color: #e63946;
  padding: 0px 5px;
  border-radius: 5px;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,yCAAyC;EACzC,eAAe,EAAE,uBAAuB;EACxC,MAAM;EACN,aAAa;EACb,kDAAkD;EAClD,YAAY,EAAE,kBAAkB;AAClC;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd","sourcesContent":["/* Container general */\n.container {\n  max-width: 1140px;\n  width: 100%;\n  margin: auto;\n  padding: auto;\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n.header {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(12, 6, 6, 0.1);\n  position: fixed; /* Face header-ul fix */\n  top: 0;\n  z-index: 1000;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n  height: 60px; /* Înălțime fixă */\n}\n\n.header.visible {\n  transform: translateY(0);\n  opacity: 1;\n}\n\n.header.hidden {\n  transform: translateY(-100%);\n  opacity: 0;\n}\n\ni {\n  padding-right: 3px;\n}\n\n.logo {\n  display: flex;\n  flex: 1;\n  justify-content: flex-start;\n  align-items: center;\n  margin: 10px 0px;\n  height: 100%;\n}\n\n.logo img {\n  max-height: 55px;\n  height: 100%;\n}\n\n.desktopNav {\n  flex: 2;\n  display: flex;\n  justify-content: center;\n}\n\n.desktopNav ul {\n  list-style: none;\n  display: flex;\n  gap: 20px;\n  margin: 0;\n  padding: 0;\n}\n\n.desktopNav a {\n  text-decoration: none;\n  color: #333;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.desktopNav a:hover {\n  color: #e63946;\n}\n\n.rightActions {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n}\n\n.rightActions a {\n  text-decoration: none;\n  color: #333;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.rightActions a:hover {\n  color: #e63946;\n}\n\n/* Buton hamburger */\n.hamburger {\n  display: none;\n  font-size: 1.5rem;\n  background: none;\n  border: 1px solid #e5e5e5;\n  border-radius: 5px;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  padding: 5px 15px;\n  margin-right: 20px;\n}\n\n.hamburger i {\n  color: #7f7f7f;\n  padding: 0;\n  margin: 0;\n}\n\n/* Meniul mobil */\n.mobileNav {\n  display: none;\n  flex-direction: column;\n  align-items: flex-end;\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: #fff;\n  width: 100%;\n  padding: 10px 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.mobileNav ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.mobileNav a {\n  text-decoration: none;\n  color: #333;\n  font-weight: 500;\n  text-align: right;\n  width: 100%;\n  padding: 10px 0;\n}\n\n.mobileNav a:hover {\n  color: #e63946;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .logo {\n    margin-left: 15px;\n  }\n\n  .desktopNav {\n    display: none;\n  }\n\n  .hamburger {\n    display: block;\n  }\n\n  .rightActions {\n    display: none;\n  }\n\n  .mobileNav {\n    display: none;\n  }\n\n  .mobileNav.open {\n    display: flex;\n  }\n}\n\n.sup {\n  background-color: #e63946;\n  padding: 0px 5px;\n  border-radius: 5px;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Header_container__vI36D`,
	"header": `Header_header__HXQOm`,
	"visible": `Header_visible__hx+eL`,
	"hidden": `Header_hidden__h44Et`,
	"logo": `Header_logo__UsziS`,
	"desktopNav": `Header_desktopNav__bvTpA`,
	"rightActions": `Header_rightActions__0DN0s`,
	"hamburger": `Header_hamburger__0Oz-R`,
	"mobileNav": `Header_mobileNav__2MJ+H`,
	"open": `Header_open__coLd6`,
	"sup": `Header_sup__3QohI`
};
export default ___CSS_LOADER_EXPORT___;
